// extracted by mini-css-extract-plugin
module.exports = {"page":"uH-z","cartModal":"vH-z","checkout":"wH-z","placeholder":"xH-z","account":"yH-z"};